export const statusColor = (
  status: string | null | undefined,
): 'default' | 'warning' | 'info' | 'success' | 'error' | 'primary' => {
  switch (status?.toUpperCase()) {
    case 'COMPLETED':
      return 'success';
    case 'CANCELLED':
      return 'error';
    // PICKED_UP, NEARBY and ARRIVED are the delivery leg (SuperPro callbacks) — same colour as ONWAY.
    case 'PICKED_UP':
    case 'ONWAY':
    case 'NEARBY':
    case 'ARRIVED':
      return 'info';
    case 'ASSIGNED':
      return 'primary';
    case 'APPROVED':
      return 'warning';
    default:
      return 'default';
  }
};
